// extracted by mini-css-extract-plugin
export var playIcon = "VideoModule-module--playIcon--y2YIn";
export var poster = "VideoModule-module--poster--EklF1";
export var posterWrapper = "VideoModule-module--posterWrapper--Ivyzv";